import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { useForm, Controller } from 'react-hook-form';
import {
  Dialog, DialogTitle, DialogContent, IconButton, useMediaQuery, useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FieldAllowanceRequestForm from '../../components/Forms/FieldAllowanceRequestForm';
import * as actions from '../../redux/actions';
import { showAlert, confirmAsync } from '../../utils/functions/globalDialog';
import { formatEmployeeThaiName } from '../../utils/functions/employeeName';

export default function AddFieldAllowanceRequest({ open, onClose, onCreated }) {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const timestamp = useSelector((state) => state.timestamp);
  const project = useSelector((state) => state.project);
  const me = useSelector((state) => state.me);
  const { control, handleSubmit } = useForm();

  const [requestForOther, setRequestForOther] = useState(false);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectedProject, setSelectedProject] = useState();
  const [date, setDate] = useState(dayjs());

  useEffect(() => {
    if (!open) return () => {};
    dispatch(actions.meGet({}));
    dispatch(
      actions.timestampAll({
        dateStart: dayjs(date).startOf('day').toISOString(),
        dateEnd: dayjs(date).endOf('day').toISOString(),
        project_id: selectedProject?._id,
      }),
    );
    return () => {};
  }, [open, date, selectedProject]);

  useEffect(() => {
    if (!open) return () => {};
    dispatch(actions.projectAll({ time_tracking_available: true, lite: true }));
    return () => {};
  }, [open]);

  // เคลียร์ฟอร์มทุกครั้งที่เปิด modal ใหม่ — กันข้อมูลค้างจากครั้งก่อน
  useEffect(() => {
    if (open) {
      setRequestForOther(false);
      setSelectedEmployees([]);
      setSelectedProject(undefined);
      setDate(dayjs());
    }
  }, [open]);

  const onSubmit = async (data) => {
    const confirm = await confirmAsync('ต้องการส่งคำขอค่าออกสนามใช่หรือไม่ ?');
    if (!confirm) return;
    if (selectedEmployees.length === 0) {
      showAlert('กรุณาเลือกพนักงาน');
      return;
    }
    if (!selectedProject) {
      showAlert('กรุณาเลือก Project');
      return;
    }

    try {
      const dataSubmit = {
        ...data,
        resquester: me?.userData?.id,
        project: selectedProject?._id,
        timestamp: selectedEmployees,
        created_by: {
          user_id: me?.userData?.id,
          username: me?.userData?.username,
          display_name: formatEmployeeThaiName(me?.userData),
        },
      };

      await dispatch(actions.fieldAllowanceRequestOrderCreate(dataSubmit));
      showAlert('ส่งคำขอค่าออกสนามเรียบร้อยแล้ว');
      onCreated?.();
      onClose?.();
    } catch (err) {
      const msg =
        err?.response?.data?.error?.message ||
        err?.response?.data?.message ||
        err?.message ||
        'เกิดข้อผิดพลาดในการส่งคำขอค่าออกสนาม';
      showAlert(msg, { status: err?.response?.status });
    }
  };

  return (
    <Dialog
      open={!!open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={isMobile}
      PaperProps={{ sx: { borderRadius: isMobile ? 0 : 3 } }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', p: 1 }}>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 0, px: { xs: 1.5, sm: 3 } }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <FieldAllowanceRequestForm
            control={control}
            Controller={Controller}
            timestamp={timestamp}
            project={project}
            requestForOther={requestForOther}
            setRequestForOther={setRequestForOther}
            selectedEmployees={selectedEmployees}
            setSelectedEmployees={setSelectedEmployees}
            selectedProject={selectedProject}
            setSelectedProject={setSelectedProject}
            date={date}
            setDate={setDate}
          />
        </form>
      </DialogContent>
    </Dialog>
  );
}
